import {useCallback, useMemo} from 'react';
import useSearchParams from './useSearchParams.js';

export default function () {
  const {searchParams, setSearchParams} = useSearchParams();

  const orgParam = searchParams.get('org');

  const orgId = useMemo(
    () => (orgParam && Number(orgParam) > 0 ? Number(orgParam) : undefined),
    [orgParam]
  );

  const setOrg = useCallback(
    id => {
      searchParams.set('org', id);
      searchParams.delete('collection');
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams]
  );

  return {orgId, setOrg};
}
